import React, { useEffect, useState } from "react";
import backgroundImage from "../../../../assets/images/billing-header.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import BillingComponent from "../../Dashboard/billing/BillingHistory";
import { ReactComponent as PurchaseCompany } from "../../../../assets/icons/PurchaseCompany.svg";
import { Button, Modal } from "../../../common";
import { useGetUserSubscriptionListQuery, useGetVerifyCompanyPaymentFetchQuery } from "../../../../store/Company/companyApiSlice";
import { useCancelSubscriptionMutation } from "../../../../store/Billing/billingApiSlice";
import { CancelSubscriptionConfirmation } from "../../../common/CancelSubscriptionConfirmatiion";
import { CancelationSuccess } from "../../../common/CancelationSuccess";
import { isAfter, isEqual } from "date-fns";

export const Subscription = () => {
  const [subscriptionCompanies, setSubscriptionCompanies] = useState([]);
  const [billingData, setbillingData] = useState([]);
  const [activeSub, setActiveSub] = useState("");
  const [hidePlan, sethidePlan] = useState(false)
  const [getConfirm, setGetConfirm] = useState(false);
  const [cancelSuccess, setCancelSuccess] = useState(false);
  const { userInfo, token } = useSelector((state) => state.auth);
  // const [subscriptionData, setSubscriptionData] = useState([]);
  const todaysDate = new Date();
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      let subscriptionArr = userInfo.individual[0]?.individual_data?.filter(
        (company) => !company.ind_compID
      );
      setSubscriptionCompanies(subscriptionArr);
    }
  }, [userInfo]);

  const subscriptionIDs = [];
  if (subscriptionCompanies?.length > 0) {

    if (subscriptionCompanies[0]?.length > 1) {
      subscriptionCompanies?.map((individual) => {
        subscriptionIDs.push(individual?.subscriptionID?.subscriptionID);
      });
    } else {
      subscriptionIDs[0] =
        subscriptionCompanies[0]?.subscriptionID?.subscriptionID;
    }
  }
  const containerStyles = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    imageRendering:'auto'
    // backgroundColor:"#002940"
  };
  let data = [];

  // TODO: there is no need to individualID in API
  const { data: subscriptionData, refetch: refetchSubscription } = useGetUserSubscriptionListQuery({
    individualID: userInfo?.individual[0]?.individualID,
    token: token
  });

  // useEffect(()=>{
  //   setSubscriptionData(subscriptions?.filter(subscription => subscription.subscription_type !== "freemium"))
  // },[subscriptions])

  // TODO: there is no need to individualID in API
  const { data: verifyCompanyData, refetch: refetchVerifiedData } = useGetVerifyCompanyPaymentFetchQuery({
    individualID: userInfo?.individual[0]?.individualID,
    token: token
  });

  useEffect(() => {
    refetchSubscription();
    refetchVerifiedData();
  }, [userInfo])

  useEffect(() => {
    let tempcompanyData;
    let tempcompanyData1;
    if (subscriptionData && verifyCompanyData?.length > 0) {
      tempcompanyData1 = verifyCompanyData.concat(subscriptionData);
    }
    else if (verifyCompanyData?.length > 0) {
      tempcompanyData1 = verifyCompanyData;
    }
    else if (subscriptionData) {
      const getActiveSub = subscriptionData?.find((i) => i?.status === "active" && i?.subscription_type !== "pay-as-you-go" && (isAfter(new Date(i.date_of_end), todaysDate) || isEqual(new Date(i.date_of_end), todaysDate)));
      const getInvalidUrl = subscriptionData?.find((i) => (i?.invoice_url === "null" && i?.subscription_type !== "freemium"));
      if (getInvalidUrl) {
        sethidePlan(true)
      }else{
        sethidePlan(false)
      }
      setActiveSub(getActiveSub);
      tempcompanyData1 = subscriptionData;
    }
    if (tempcompanyData1 != undefined) {
      tempcompanyData = tempcompanyData1.slice().sort((a, b) => {
        return new Date(b?.date_of_start) - new Date(a?.date_of_start)
      });
      // const tempDataSet = tempcompanyData?.filter((company) => company?.subscription_type !== "freemium")
      setbillingData(tempcompanyData)
    }
  }, [subscriptionData, verifyCompanyData, activeSub]);
  const plan = [
    {
      subscription_type: "pay-as-you-go",
      profile: 1,
      amount: 79,
    },
    {
      subscription_type: "basic",
      profile: 3,
      amount: 195,
    },
    {
      subscription_type: "pro",
      profile: 5,
      amount: 275,
    },
    {
      subscription_type: "premium",
      profile: 10,
      amount: 500,
    },

  ];
  const getSubAmount = (subscription_type) => {
    const res = plan?.find((i) => i?.subscription_type === subscription_type);
    return res?.amount;
  };

  const handleNavigate = () => {
    localStorage.setItem("UpgradePlan", true);
    window.scrollTo(0, 0);
    navigate("/plans");
  };

  const onDownloadInvoiceAll = () => {
    const getAllPdf = data?.map((i) => i?.trevex_invoice ? i?.trevex_invoice : i?.invoice_url);
    const downloadPdf = (url) => {
      const a = document.createElement("a");
      a.href = url;
      a.target = '_blank';
      a.download = "invoice.pdf";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    getAllPdf.forEach((url) => {
      downloadPdf(url);
    });
  };

  const onDownloadInvoice = (url) => {
    window.open(url, '_blank');
  };

  const [cancelSubscription] = useCancelSubscriptionMutation();
  const [cancelled, setCancelled] = useState("");

  useEffect(() => {
    const res = subscriptionData?.find((i) => i?.status === "active" && i?.subscription_type !== "pay-as-you-go" && (isAfter(new Date(i.date_of_end), todaysDate) || isEqual(new Date(i.date_of_end), todaysDate)));
    setActiveSub(res);
    setCancelled(res?.recurring_status);
  }, [subscriptionData, userInfo]);

  const handleCancelSubscription = async () => {
    const res = await cancelSubscription(activeSub?.stripe_subscription_id);
    if (res) {
      setGetConfirm(false);
      setCancelSuccess(true);
      setCancelled(res?.data?.message);
    }
  };
  return (
    <>
      {(billingData?.length > 0 || subscriptionData?.length > 0) ? (
        <>
          <div className="p-4 sm:p-6 rounded-lg my-4" style={containerStyles}>
            {activeSub?.subscription_type ?
              <div className="flex flex-col sm:flex-row justify-between py-4 items-center">
                <div className="text-start ">
                  <h3 className="text-slate text-f18 pb-2 capitalize">
                    {activeSub?.subscription_type || "No Subscription"}
                  </h3>
                  {activeSub?.subscription_type === "pay-as-you-go" ? null : (
                    <p className="text-slate text-f14 font-extralight">
                      pay on a monthly subscription
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-2 text-start">
                  <span className="text-slate text-f36 font-bold">
                    ${getSubAmount(activeSub?.subscription_type) || 0}
                  </span>
                  <p className="text-slate text-f14 font-extralight">
                    per month
                  </p>
                </div>
              </div> :
              <><div className="flex flex-col sm:flex-row justify-between py-4 items-center">
                <div className="text-start ">
                  <h3 className="text-slate text-f18 pb-2 capitalize">
                    {"No Active Subscription"}
                  </h3>
                </div>
                <div className="flex items-center gap-2 text-start">
                  <div className="">
                    <button
                      className="text-slate border flex justify-between gap-5 items-center border-white text-f18 font-semibold p-4 rounded-lg"
                      onClick={handleNavigate}
                    >
                      Buy a plan
                      <span>
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.5 13L13.5 1M13.5 1H4.5M13.5 1V10"
                            stroke="#EBF0F3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              </>}
            {activeSub?.subscription_type && <hr />}
            {activeSub?.subscription_type && <div className="flex justify-between py-4 items-center flex-col sm:flex-row gap-3">
              <div className="text-start flex flex-col gap-2">
                <span className="text-slate text-f14  font-extralight">
                  No. of profile credits remaining :{" "}
                  <b className="text-f16">
                    {" "}
                    {activeSub?.no_of_profile_views || 0}
                  </b>
                </span>
                <span className="text-slate text-f14 font-extralight">
                  Last Access : {activeSub?.date_of_end || "No Subscription"}
                </span>
              </div>
              {!hidePlan && <div className="">
                <button
                  className="text-slate border flex justify-between gap-5 items-center border-white text-f18 font-semibold p-4 rounded-lg"
                  onClick={handleNavigate}
                >
                  Modify plan
                  <span>
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.5 13L13.5 1M13.5 1H4.5M13.5 1V10"
                        stroke="#EBF0F3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </div>}
            </div>}
          </div>

          {!hidePlan && <BillingComponent
            data={billingData.length > 0 ? billingData : subscriptionData}
            activeSub={activeSub}
            cancelled={cancelled}
            setGetConfirm={setGetConfirm}
            getSubAmount={getSubAmount}
            onDownloadInvoiceAll={onDownloadInvoiceAll}
            id={activeSub?.subscriptionID}
            onDownloadInvoice={(data) => onDownloadInvoice(data)}
          />}
        </>
      ) : (
        <div className="flex flex-col items-center gap-5 justify-center w-1/3 mx-auto p-5 pkpp">
          <PurchaseCompany />
          <span className="text-secondary text-f14 w-2/3">
            All your Bilings will appear here
          </span>
          <Button
            onClick={handleNavigate}
            classes="border-link text-f14 text-link font-semibold border py-2 px-5 rounded"
          >
            Start Purchasing
          </Button>
        </div>
      )}
      {getConfirm && (
        <Modal modalHandle={() => setGetConfirm(false)}>
          <CancelSubscriptionConfirmation
            onclick={() => setGetConfirm(false)}
            handleCancelSubscription={handleCancelSubscription}
            title={" Are you sure?"}
            des2={`Your current subscription will end on <b>${new Date(
              activeSub?.date_of_end
            ).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}</b>`}
            des={`Please confirm your decision to cancel your subscription. Remember, upon cancellation, you'll lose access to all premium features.`}
            leftButton={"Keep Subscription"}
            rightButton={"Confirm Cancellation"}
          />
        </Modal>
      )}

      {cancelSuccess && (
        <Modal modalHandle={() => setCancelSuccess(false)}>
          <CancelationSuccess
            title={"Subscription Cancelled?"}
            des2={`Your current subscription will end on <b>${new Date(
              activeSub?.date_of_end
            ).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}</b>`}
            des={`We're sad to see you go. Your subscription has been cancelled. You'll have access to premium features until the end of your billing cycle.`}
          />
        </Modal>
      )}
    </>
  );
};
